import React, { useContext, useEffect, useState } from "react";
import UserApplication from "./Users/UserContext/UserContext";

const Notification = () => {
    let data = useContext(UserApplication)
    const { Notice ,SetNotification} = data


    const [display, setDisplay] = useState('none')
    useEffect(() => {
        try {
            fun()
        } catch (error) {
            console.error('Error in Notification useEffect:', error);
            throw error;
        }
    }, [Notice])

    let fun=()=>{
        try {
            if(Notice.notice.length>0){
                setDisplay('grid')
            }
            setTimeout(() => {
                setDisplay('none')
                SetNotification({
                    notice:"",
                    color:""
                })
            }, 3000);
        } catch (error) {
            console.error('Error in Notification fun:', error);
            throw error;
        }
    }

    return (
        <>
            <div className="card form-control" style={{ display: display, position: "absolute", zIndex: "100", backgroundColor: Notice.color }}>

                <div className="card-body">
                    <h5 className="card-title"></h5>
                    <p className="card-text">{Notice.notice}</p>
                </div>
                <div style={{ display: "grid", justifyContent: "end" }}>
                    <button className="btn btn-close mb-3 mx-3" aria-label="close" style={{ border: "2px solid red", width: "1rem", height: "1rem", borderRadius: "20px" }} onClick={() => setDisplay('none')}></button>
                </div>
            </div>
        </>
    )

}

export default Notification